<template>
  <v-card>
    <v-card-title>
      <v-avatar size=48>
        <img :src="logoThumbUrl" alt="Avatar" v-if="logoThumbUrl">
        <v-icon color="primary" large v-else>ballot</v-icon>
      </v-avatar>
      <span class="subheading pl-2">
        {{project.attributes.name}}
      </span>
    </v-card-title>

    <v-card-text>
      <p class='subheading font-weight-medium'>
        Deleting this project will remove all related information. This action cannot be undone.
      </p>

      <div class="text-capitalize text-uppercase">Current project resources</div>
      <hr>
      <v-layout row wrap>
        <!-- v-flex class="xs6 subheading font-weight-medium">Storage</v-flex><v-flex class="xs6 subheading">{{project.attributes.storage|toFileSize}}</v-flex -->
        <v-flex class="xs6 subheading font-weight-medium">Tickets</v-flex><v-flex class="xs6 subheading">{{project.attributes.ticket_count}}</v-flex>
        <v-flex class="xs6 subheading font-weight-medium">Members</v-flex><v-flex class="xs6 subheading">{{project.attributes.member_count}}</v-flex>
      </v-layout>
      <hr>
      <br>
      <p class='subheading red--text'>
        Are you sure you want to delete <span class="font-italic font-weight-black">{{project.attributes.name}}</span> ?
      </p>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat color="primary" @click="cancelDeleteProject(project)">Cancel</v-btn>
      <v-btn color="error" @click="deleteProject()" :loading="busy">Delete</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { EventBus } from '@/utilities/event-bus'
  // import permissions from '@/utilities/permissions'

  import projectService from '@/services/project'

  export default {
    name: 'project-delete',

    props: ['project'],

    data () {
      return {
        // permit: permissions,
        busy: false
      }
    },

    computed: {
      logoThumbUrl () {
        if (this.project.links && this.project.links.logo_thumb_uri) {
          return (process.env.API_URL + this.project.links.logo_thumb_uri)
        }
        return null
      }
    },

    mounted () {
    },

    methods: {
      cancelDeleteProject () {
        EventBus.$emit('project-deleted')
      },

      deleteProject () {
        this.busy = true
        projectService.delete(
          (data) => {
            this.busy = false
            EventBus.$emit('project-deleted', this.project)
          },
          (err) => {
            this.busy = false
            console.log(err)
          },
          this.project.id
        )
      },

      validate () {
        if (this.$refs.form.validate()) {
          // TODO
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/project/_delete.vue